module.exports = __webpack_public_path__ + "img/tu7@2x.52247f6a.png";